import { BaseApi, ResponseEntity } from "@/utils/request";

export class DictionaryApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * List
   */
  public getTreeData(): Promise<ResponseEntity> {
    return this.get("/Dictionary/GetTreeData");
  }

  public getDictionaryDetail(id: number) {
    return this.get("/Dictionary/GetDictionaryDetail", { id });
  }

  public searchDictionary(searchKey: string) {
    return this.get("/Dictionary/SearchDictionary", { searchKey });
  }

  public getExtInfo(id: number) {
    return this.get("/Dictionary/GetExtInfo", { id });
  }
}
